import React, { Fragment, useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import AuthButtons from "../../UI/AuthButtons.jsx";
import Loader from "../../Loader/Loader.jsx";

import { useStore } from "../../../hook-store/store.js";
import { uploadLargeFileForProcess } from "../../../utils/large-file-upload-utils/large-file-upload-utils.js";

import { 
  loginPageLink,
  signupPageLink,
  TEXTAUDIOTOOLSNODE_URL,
} from "../../../App.js";

import "./TranscribeAction.css";
import { marks } from "../../../utils/marks.jsx";

export default function TranscribeAction(props) {
    const { 
      // audioData, 
      uploadApp,
    } = props;


    const [t] = useTranslation("translation");

    const [store, dispatch] = useStore();
    const { 
        mlSpeechCurrentAudioData,
        mlSpeechInputFileName,
        mlSpeechText,
        mlSpeechSrtText,
        mlSpeechSelectedLanguage,
        mlSpeechSelectedModel,
        mlSpeechToTextConfig,
        mlSpeechIsUserGenerating,
        mlSpeechIsServerBusy,
        mlSpeechIsServer,
    } = store.mlSpeechStore;
    const { 
      usageBasedConfig,
      usageBasedSubscription,
      usageBasedValidMethod,
      usageBasedPrice,
    } = store.stripeData;
    const {
      isAuth,
    } = store.uiStore;

    const [showAllOutputText, setShowAllOutputText] = useState(false);
    const [showSrtContent, setShowSrtContent] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
      setShowAllOutputText(false);
    },[mlSpeechText]);


    // const createFileFromSourceUrl = async (url) => {
    //   try {
    //     const response = await fetch(url);

    //     const resData = await response.blob();

    //     console.log(response, resData);

    //     if (resData) {
    //       const file = new File([resData], 'test-file.wav', {type: resData.type})
    //       // setFi(file);
    //     }

    //   } catch(err) {
    //     console.log(err);
    //     throw err;
    //   }
    // };


    const transcribeAudioHandler = async (url) => {
      try {
        setIsLoading(true);
        setErrorMessage('');

        dispatch('SET_MLSPEECHISUSERGENERATING', true);
        // throw new Error('error-error')

        const response = await fetch(url);

        const resBlob = await response.blob();

        // console.log(response, resBlob);

        if (resBlob) {
          const nameSplits = mlSpeechInputFileName.split('.');
          const ext = nameSplits.pop();
          const fileName = `upload-${Date.now()}.${ext}`;
          const file = new File([resBlob], fileName, {type: resBlob.type})
          // console.log(file);
          // throw new Error('error-error')
          // setFi(file);

          
          const formData = new FormData();
          if (mlSpeechSelectedLanguage) {
            formData.append('language', mlSpeechSelectedLanguage);
          }
          if (mlSpeechSelectedModel) {
            formData.append('repo_id', mlSpeechSelectedModel);
          }
          formData.append('add_punctuation', true);
          formData.append('file_ext', ext);
          formData.append('files', file);

          formData.append('customerId', localStorage.getItem('customerId'));
          formData.append('userId', localStorage.getItem('userId'));
          formData.append('originalFileName', mlSpeechInputFileName);
          
          if (usageBasedPrice) {
            formData.append('priceId', usageBasedPrice.id);
          }


          if (mlSpeechInputFileName === 'recorded-audio.wav') {
            const duration = mlSpeechCurrentAudioData.buffer.duration;
            formData.append('recordedDuration', duration);
          }
          
          const url = TEXTAUDIOTOOLSNODE_URL + `/speech-to-text/generate-file-audio-text`;
          const result = await fetch(url, {
            method: 'POST',
            headers: {
              // 'Content-Type': 'application/json',
              Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
            body: formData,
            // body: JSON.stringify({
            //   "language": "English",
            //   "repoId": "csukuangfj/sherpa-onnx-nemo-parakeet-tdt-0.6b-v3-int8",
            //   "addPunctuation": true,
            //   // "in_filename": "",
            //   "fileExt": "wav",
            //   "base64String": base64data,
            //   "priceId": "",
            //   "customerId": "",
            // }),
          });
    
          const resData = await result.json();
          console.log(result, resData);
          
          if (resData.data && resData.data.all_text) {
            dispatch('SET_MLSPEECHTEXT', resData.data.all_text);
          }

          if (resData.data && resData.data.srt_data) {
            dispatch('SET_MLSPEECHSRTTEXT', resData.data.srt_data)
          }
        
        }

        setIsLoading(false);

        setTimeout(() => {
          dispatch('SET_MLSPEECHISUSERGENERATING', false);
        },1000*20);

      } catch(err) {
        console.log(err);
        setIsLoading(false);
        setErrorMessage('Audio transcribe failed');
        
        dispatch('SET_MLSPEECHISUSERGENERATING', false);
        // setTimeout(() => {
        //   dispatch('SET_MLSPEECHISUSERGENERATING', false);
        // },1000*20);
        
        throw err;
      }
    }


    const transcribeAudioHandler2 = async (url) => {
      try {
        setIsLoading(true);
        setErrorMessage('');

        dispatch('SET_MLSPEECHISUSERGENERATING', true);
        // throw new Error('error-error')

        const response = await fetch(url);

        const resBlob = await response.blob();

        // console.log(response, resBlob);

        if (resBlob) {
          const nameSplits = mlSpeechInputFileName.split('.');
          const ext = nameSplits.pop();
          const fileName = `upload-${Date.now()}.${ext}`;
          const file = new File([resBlob], fileName, {type: resBlob.type})
          // console.log(file);
          // throw new Error('error-error')
          // setFi(file);
          let priceId;

          if (usageBasedPrice) {
            priceId = usageBasedPrice.id;
          }
        
          const dataForProcess = {
            language: mlSpeechSelectedLanguage,
            repo_id: mlSpeechSelectedModel,
            originalFileName: mlSpeechInputFileName,
            fileSize: file.size,
            uploadApp: uploadApp,
          };

          const response = await uploadLargeFileForProcess(
            TEXTAUDIOTOOLSNODE_URL,
            `/speech-to-text/generate-file-audio-text2`,
            localStorage.getItem('token'),
            file,
            5*10**6,
            localStorage.getItem('customerId'),
            priceId,
            dataForProcess,
          );

          if (!response.ok) {
            throw new Error('error occured')
          }

          const resData = await response.json()
          console.log(response, resData);
          // throw new Error('error-error')

 
          if (resData.data && resData.data.all_text) {
            dispatch('SET_MLSPEECHTEXT', resData.data.all_text);
          }

          if (resData.data && resData.data.srt_data) {
            dispatch('SET_MLSPEECHSRTTEXT', resData.data.srt_data)
          }

          dispatch('SHOW_NOTIFICATION', {
            status: '',
            title: `${t('audioTranscriber45', 'file processing')} ${t('audioTranscriber46', 'success')}`,
            message: '',
          });

          setTimeout(() => {
            dispatch('CLEAR_NOTIFICATION');
          }, 1000*10);
        
        }

        setIsLoading(false);

        setTimeout(() => {
          dispatch('SET_MLSPEECHISUSERGENERATING', false);
        },1000*20);

      } catch(err) {
        console.log(err);
        setIsLoading(false);
        setErrorMessage(`${t('audioTranscriber47', 'Audio transcribe')} ${t('audioTranscriber48', 'failed')}`);

        dispatch('SHOW_NOTIFICATION', {
          status: 'error',
          title: `${t('audioTranscriber47', 'Audio transcribe')} ${t('audioTranscriber48', 'failed')}`,
          message: '',
        });
        
        dispatch('SET_MLSPEECHISUSERGENERATING', false);
        // setTimeout(() => {
        //   dispatch('SET_MLSPEECHISUSERGENERATING', false);
        // },1000*20);
        
        throw err;
      }
    };


    const shortTextLength = 500
    let outputTextEl;

    if (mlSpeechText && mlSpeechText.length > shortTextLength) {
      if (!showAllOutputText) {
        outputTextEl = (
          <div>
            <div>
              <span>
                {mlSpeechText.slice(0,shortTextLength)}.....
              </span>
              <span
                onClick={() => {
                  setShowAllOutputText(true);
                }}
              >
                {' '}({t('audioTranscriber24', 'Display all output')} {marks.triangleDown})
              </span>

            </div>
            <div>
            </div>
          </div>
        );
      } else {
        outputTextEl = (
          <div>
            <div>{mlSpeechText}</div>
            <div>
              <span
                onClick={() => {
                  setShowAllOutputText(false)
                }}
              >
                {t('audioTranscriber25', 'Display less text')} {marks.triangle}
              </span>
            </div>
          </div>
        );
      }
    }

    if ((mlSpeechText && mlSpeechText.length <= shortTextLength)) {
      outputTextEl = (
        <span>{mlSpeechText}</span>
      );
    }


    // let selectedLngModels = [];
    let genButtonDisabled = false;
    let genButtonText = `stt-gen-button-text`;
    // let numberOfSpeakerId = 1;



    if (isLoading || !mlSpeechSelectedLanguage || !mlSpeechSelectedModel
        || mlSpeechIsServerBusy || mlSpeechIsUserGenerating
    ) {
      genButtonDisabled = true;
    }

    console.log('mlSpeechIsServerBusy, mlSpeechIsServer', mlSpeechIsServerBusy, mlSpeechIsServer, mlSpeechIsUserGenerating)
    // if (!textToSpeechApiExist || isVoiceGenerating || isUserGenerating) {
    //   genButtonDisabled = true;
    //   genButtonText = `${t('voiceGenerator08', 'Busy...')}`
    // }

    // if (textInput && textInput.length > ttsGenMaxText) {
    //   genButtonDisabled = true;
    // }


    let isUsageBased = false;
    let isUsageBasedOk = true;
    let ubbUnit = 0;
    let fileDuration = 0;

    if (mlSpeechCurrentAudioData?.buffer?.duration) {
      fileDuration = mlSpeechCurrentAudioData.buffer.duration;
    }

    if (mlSpeechToTextConfig && 
        fileDuration > mlSpeechToTextConfig.sttFreeMaxTime
    ) {

      isUsageBased = true;

      if (usageBasedConfig) {
        // isUsageBased = true;
        const billTime = fileDuration - mlSpeechToTextConfig.sttFreeMaxTime;
        const unitFactor = Math.ceil(billTime / mlSpeechToTextConfig.sttUnitTime);
        console.log('fileDuration', fileDuration)
        console.log('billTime', billTime)
        console.log('unitFactor', unitFactor)
        if (unitFactor >= 1) {
          const baseUnit = usageBasedConfig.speechToTextUnit;
          ubbUnit = Math.round(baseUnit*unitFactor);
        }
  
        console.log('ubbUnit', ubbUnit);
      }
    }

    if (isUsageBased && 
        (!isAuth || !usageBasedSubscription || !usageBasedValidMethod)
    ) {
      isUsageBasedOk = false;
      genButtonDisabled = true;
    }

    if (!isAuth) {
      genButtonDisabled = true;
    }

    console.log('isUsageBased, isUsageBasedOk', isUsageBased, isUsageBasedOk);
    


    let transcribeActionBody;

    if (mlSpeechCurrentAudioData) {
      transcribeActionBody = (
        <div>
          {ubbUnit > 0 && (
            <div className='voiceGenerator2Section'>
              Unit{' '}
              <strong>
                {ubbUnit}
                {' '}
                ({(Number(usageBasedPrice.unit_amount_decimal)/100*ubbUnit).toFixed(2)} USD)
              </strong>
            </div>
          )}

          {isUsageBased && !isAuth && (
            <div>
              <div className='voiceGenerator2Section'>
                <strong>
                  {t('audioTranscriber26', 'For longer audio, User need to enable usage based billing after login.')}
                </strong>
                {mlSpeechToTextConfig && (
                  <div>
                    ({t('audioTranscriber27', 'more than')} 
                      {' '}{mlSpeechToTextConfig.sttFreeMaxTime}
                      {t('audioEditor16', 'seconds')})
                  </div>
                )}
                {' '}(~0.01 USD) 
              </div>
              <div className='voiceGenerator2Section'>
                <a href={loginPageLink}>
                  <button className="btnBase">
                    {marks.signInMrak} {t('aboutAuth06', 'Login')}
                  </button>
                </a>
                <span> or </span>
                <a href={signupPageLink}>
                  <button className="btnBase">
                    {marks.userPlusMrak} {t('aboutAuth07', 'Signup')}
                  </button>
                </a>
              </div>
            </div>
          )}

          {isUsageBased && usageBasedPrice && usageBasedConfig && mlSpeechToTextConfig && (
            <div>
              <div className='voiceGenerator2Section'>
                <strong>
                  {t('audioTranscriber28', 'Because text generation from longer audio uses a lot of resources, payment is required.')}
                  {' '}({t('audioTranscriber27', 'more than')} 
                  {' '}
                  {mlSpeechToTextConfig.sttFreeMaxTime}
                  {t('audioEditor16', 'seconds')})
                  {' '}(~{Number(usageBasedPrice.unit_amount_decimal)/100*usageBasedConfig.speechToTextUnit} USD)
                  {/* {' '}{usageBasedPrice.unit_amount_decimal}
                  {' '}{usageBasedConfig.speechToTextUnit} */}
                </strong>
              </div>
            </div>
          )}


          {isUsageBased && isAuth && !usageBasedSubscription && (
            <div className='voiceGenerator2Section'>
              <div>
                <strong>
                  {t('voiceGenerator19', 'Enabling usage based billing is required.')}
                </strong>
              </div>
              <Link
                to="/usage-based-billing"
              >
                <button className='btnBase'>
                  {t('voiceGenerator20', 'Go to usage based billing page')}
                </button>
              </Link>
            </div>
          )}

          {isUsageBased && isAuth && usageBasedSubscription && !usageBasedValidMethod && (
            <div className='voiceGenerator2Section'>
              <div>
                <strong>
                  {t('voiceGenerator21', 'Card information for payment is required.')}
                </strong>
              </div>
              <Link
                to="/usage-based-billing"
              >
                <button className='btnBase'>
                  {t('voiceGenerator20', 'Go to usage based billing page')}
                </button>
              </Link>
            </div>
          )}

          <div className="transcribeActionRow">
            <button className="transcribeActionButton"
              disabled={genButtonDisabled}
              onClick={() => {
                // transcribeAudioHandler(mlSpeechCurrentAudioData.url);
                transcribeAudioHandler2(mlSpeechCurrentAudioData.url);
              }}
            >
              {t('audioTranscriber29', 'Transcribe Audio')}
            </button>

            {!isAuth && (
              <div>
                <div className='videoToAudioSection'>
                  {t('videoToAudio13', 'Login is required.')}
                </div>
                <div className='videoToAudioSection'>
                  <AuthButtons />
                </div>
              </div>
            )}

          {(
            mlSpeechIsServerBusy || mlSpeechIsUserGenerating
            ) && (
            <div>busy...</div>
          )}

        {/* {(mlSpeechIsServerBusy) && (
            <div>server-busy...</div>
        )} */}

            {isLoading && (
              <Loader />
            )}
          </div>
          {errorMessage && (
            <div className="transcribeActionRow"
              style={{color: "red"}}
            >
              <strong>
                {errorMessage}
              </strong>
            </div>
          )}

          <div className="transcribeActionRow">
            <div>
              <strong>
                {t('audioTranscriber30', 'Text output')}
              </strong>
              </div>
            <div className="transcribeActionTextOutput">
              {outputTextEl}
            </div>
          </div>

          <div className="transcribeActionRow">
            <div>
              <span
                onClick={() => {
                  setShowSrtContent(!showSrtContent);
                }}
              >
                {t('audioTranscriber31', 'Display srt output (for subtitles)')} {marks.triangleDown}
              </span>
            </div>
            {showSrtContent && (
              <div className="transcribeActionSrtOutput"
                // style={{border: "1px solid red" ,whiteSpace: "pre-wrap"}}
              >
                <div>
                  {mlSpeechSrtText}
                </div>
                <br/>

                <div>
                  <span
                    onClick={() => {
                      setShowSrtContent(false)
                    }}
                  >
                    {t('audioTranscriber32', 'Hide srt output')} {marks.triangle}
                  </span>
                </div>
              </div>
            )}
          </div>


 
        </div>
      );
    }


    return (
        <Fragment>
          <div>{transcribeActionBody}</div>
        </Fragment>
    );
  };
